/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {DB_Patient} from "@app/app-shared/patient";
import {BaseDB_ApiGeneratorCaller} from "@intuitionrobotics/db-api-generator/frontend";
import {getRelevantGroupContactIds} from "./utils";
import {UsersModule} from "@modules/UsersModule";
import {DB_Contact} from "@app/ir-q-app-common/types/db-contact";
import {GroupType} from "@app/ir-q-app-common/types/contacts";
import {PatientsContextType} from "../app/pages/ui/patients/PatientsContext";
import {BaseHttpRequest} from "@intuitionrobotics/thunderstorm";
import {ApiBinder_DBCreate, ApiBinder_DBUniuqe} from "@intuitionrobotics/db-api-generator/shared/types";
import {ApiBinder_DBDelete, ApiBinder_DBQuery} from "@intuitionrobotics/db-api-generator";
import {OrganizationMap} from "../app/pages/ui/organizations/OrganizationsContext";
import {ContactsMap} from "../app/pages/ui/messages/ContactsContext";

export class PatientsModule_Class
    extends BaseDB_ApiGeneratorCaller<DB_Patient> {

    public getGroupRecipients(organizations: OrganizationMap, {patients, patientIds}: PatientsContextType, contacts: ContactsMap, groupType?: GroupType): DB_Patient[] {
        const user = UsersModule.getCurrentUserByEmail();
        if (!user)
            return []

        const groupContactIds = getRelevantGroupContactIds(organizations);

        if (!groupContactIds || groupContactIds.length === 0)
            return [];

        const groupContacts = groupContactIds.reduce((carry: DB_Contact<"group">[], _id) => {
            const groupContact = contacts[_id];

            if (!groupContact)
                return carry

            if (!groupType || groupContact.contactData.type === groupType)
                carry.push(groupContact)

            return carry
        }, []);

        if (!patientIds.length)
            return [];

        return Object.values(patients).filter(patient => patient && groupContacts.some(groupContact => groupContact.connections.find(connection => connection._id === patient?.contactId))) as DB_Patient[];
    }

    create(): BaseHttpRequest<ApiBinder_DBCreate<DB_Patient>> {
        throw new Error("Method not implemented.");
    }

    delete = (): BaseHttpRequest<ApiBinder_DBDelete<DB_Patient>> => {
        throw new Error("Method not implemented.");
    }

    update = (): BaseHttpRequest<ApiBinder_DBCreate<DB_Patient>> => {
        throw new Error("Method not implemented.");
    }

    unique = (): BaseHttpRequest<ApiBinder_DBUniuqe<DB_Patient>> => {
        throw new Error("Method not implemented.");
    }

    query = (): BaseHttpRequest<ApiBinder_DBQuery<DB_Patient>> => {
        throw new Error("Method not implemented.");
    }
}

export const PatientsModule = new PatientsModule_Class({key: "patient", relativeUrl: "/v1/patient"}, "PatientsModule");
